module.exports = __webpack_public_path__ + "media/images/consumer/signup/plans/prepared-checkout-874076ed75776f282b0adc390595a1f6.jpg";